<template>
	<section class="fac-card-tab" :active="active">
        <!-- @slot Para inserir os cards -->
        <slot></slot>
	</section>
</template>
<script>
	export default {
        name: 'ui-card-tab-main',
        props: {
            active: {
				type: String,
				required: true,
			},
        },
		methods: {
			currentOpen(content){
                this.$emit("current", content);
            }
        },
		mounted(){
            this.$on("open", (content) => {
                this.currentOpen(content)
            });

            this.currentOpen(this.active)
		}
    };
</script>

<style lang="stylus" scoped>
    @import '../styles.styl';
</style>

